import { Link } from 'react-router-dom';
import { api, type Segnale } from '../api';
import { Etichetta, Scheda, useCarico } from '../componenti/base';

/**
 * Cosa merita attenzione, adesso.
 *
 * Il materiale c'era già, ma sparso: lo scaduto si vedeva aprendo il
 * previsionale, l'F24 non versato la pagina F24, l'estratto conto fermo la
 * testata del cruscotto. Ogni pezzo visibile **a chi lo va a cercare**, e
 * nessuno va a cercare un guaio che non sa di avere.
 *
 * Sta sulla scheda **Cassa** e non sull'andamento perché è la prima che si
 * apre: un elenco di cose da fare che bisogna andare a scoprire non è un
 * elenco di cose da fare.
 *
 * Se cade, cade da sola: il cruscotto attorno resta in piedi. Un riquadro di
 * segnalazioni che porta giù la pagina che sorveglia sarebbe il peggio.
 */
export function Segnali() {
  const { dati, caricamento, errore } = useCarico(() => api.get<Segnale[]>('/api/segnali'), []);
  if (caricamento || errore || !dati || dati.length === 0) return null;

  const daFare = dati.filter((s) => s.gravita === 'ATTENZIONE');

  return (
    <Scheda
      titolo="Cosa merita la tua attenzione"
      sottotitolo={
        daFare.length > 0
          ? `${daFare.length} ${daFare.length === 1 ? 'cosa chiede' : 'cose chiedono'} di essere sistemate`
          : 'Niente di urgente'
      }
    >
      <ul className="space-y-3">
        {dati.map((s) => (
          <li key={s.chiave} className="flex items-start gap-3">
            <span className="mt-0.5 shrink-0">
              <Etichetta
                testo={s.gravita === 'ATTENZIONE' ? 'da fare' : 'nota'}
                tono={s.gravita === 'ATTENZIONE' ? 'attenzione' : undefined}
              />
            </span>
            <span className="text-sm">
              <span className="block font-medium">{s.titolo}</span>
              <span className="text-inchiostro-600">{s.testo}</span>
              {s.dove && (
                <>
                  {' '}
                  <Link to={s.dove} className="underline decoration-dotted underline-offset-2">
                    vai
                  </Link>
                </>
              )}
            </span>
          </li>
        ))}
      </ul>
    </Scheda>
  );
}
